// Event Names
export const MEDIA_PLAY_EVENT = 'MEDIA_PLAY_EVENT';
export const MARKER_CLICK_EVENT = 'MARKER_CLICK_EVENT';
export const OVERLAY_CLICK_EVENT = 'OVERLAY_CLICK_EVENT';
export const PROGRESS_CLICK_EVENT = 'PROGRESS_CLICK_EVENT';
export const ANNOTATION_CLICK_EVENT = 'ANNOTATION_CLICK_EVENT';

// Types
export const AUDIO_TYPE = 'audio';
export const VIDEO_TYPE = 'video';
export const IMAGE_TYPE = 'image';
export const PDF_TYPE = 'pdf';
